import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Container } from '../../grid';
import Logo from '../Logo/index';
import PhoneBox from './PhoneBox';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function () { return ({
    logoLink: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    logo: {
        width: '110px',
    },
    paperShadow: {
        marginBottom: '0.2em',
        borderRadius: 0,
        boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    },
    paperFlat: {
        marginBottom: '0.2em',
        borderRadius: 0,
        boxShadow: 'none !important',
    },
    containerRoot: {
        minHeight: '58px',
        padding: '8px 16px',
        display: 'flex !important',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}); };
/**
 * Renders the Header Component. The right side content is changing according the context, so it can be supplied via props,
 * same goes for the content for the bottom in case you need to squeeze some more content into the header section like
 * a nav bar for example.
 */
function Header(_a) {
    var contentRight = _a.contentRight, contentBottom = _a.contentBottom, _b = _a.redirectLink, redirectLink = _b === void 0 ? 'https://smava.de' : _b, hidePhone = _a.hidePhone, phoneNumber = _a.phoneNumber, isFlat = _a.isFlat;
    var classes = useEmotionStyles(styles);
    return (React.createElement("header", null,
        React.createElement(Paper, { className: isFlat ? classes.paperFlat : classes.paperShadow },
            React.createElement(Container, { className: classes.containerRoot },
                React.createElement("a", { className: classes.logoLink, href: redirectLink, "aria-label": "smava - Ihr Kredit ist da." },
                    React.createElement(Logo, { className: classes.logo })),
                React.createElement(Box, { display: "flex" },
                    contentRight,
                    !hidePhone && React.createElement(PhoneBox, { phoneNumber: phoneNumber })))),
        contentBottom));
}
export default Header;
